/**
 * Format a number as currency using standard international formatting.
 * Default: USD, en-US locale.
 */
export function formatMoney(n: number, currency: string = "USD", locale: string = "en-US"): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Math.round(n));
}

/**
 * Short abbreviation: 1.2M / 340K / 12.5B
 */
export function formatMoneyShort(n: number, currency: string = "USD"): string {
  const sym = new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 })
    .formatToParts(0)
    .find((p) => p.type === "currency")?.value ?? "$";
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  if (abs >= 1_000_000_000) return `${sign}${sym}${(abs / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000) return `${sign}${sym}${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${sign}${sym}${(abs / 1_000).toFixed(1)}K`;
  return `${sign}${sym}${Math.round(abs).toLocaleString("en-US")}`;
}
